<template>
    <div class="container">
        <h1>
            Regulamin Monitoringu Wizyjnego Holistic Sport Center Sp. z o.o.
        </h1>

        <h2>§1. Postanowienia ogólne</h2>
        <ol>
            <li>
                Niniejszy regulamin określa zasady funkcjonowania systemu
                monitoringu wizyjnego na terenie Holistic Sport Center Sp. z
                o.o., zwanego dalej „Klubem”.
            </li>
            <li>
                Celem monitoringu jest zapewnienie bezpieczeństwa osób
                przebywających na terenie Klubu oraz ochrona mienia Klubu.
            </li>
            <li>
                Monitoring funkcjonuje całodobowo i obejmuje wyłącznie obraz
                (bez dźwięku).
            </li>
        </ol>

        <h2>§2. Podstawa prawna</h2>
        <ol>
            <li>
                Przetwarzanie danych osobowych w postaci wizerunku odbywa się na
                podstawie art. 6 ust. 1 lit. f RODO, tj. w celu realizacji
                prawnie uzasadnionego interesu administratora danych, jakim jest
                zapewnienie bezpieczeństwa osób i mienia.
            </li>
            <li>
                W przypadku pracowników, monitoring prowadzony jest zgodnie z
                art. 22<sup>2</sup> Kodeksu pracy oraz art. 6 ust. 1 lit. c
                RODO.
            </li>
        </ol>

        <h2>§3. Zakres monitoringu</h2>
        <ol>
            <li>
                Monitoring obejmuje przestrzenie ogólnodostępne Klubu, takie
                jak:
                <ul>
                    <li>wejścia i wyjścia,</li>
                    <li>recepcję,</li>
                    <li>strefy treningowe,</li>
                    <li>korytarze i ciągi komunikacyjne.</li>
                </ul>
            </li>
            <li>
                Monitoring nie obejmuje pomieszczeń, w których naruszałby
                intymność osób, takich jak:
                <ul>
                    <li>szatnie,</li>
                    <li>toalety,</li>
                    <li>prysznice.</li>
                </ul>
            </li>
        </ol>

        <h2>§4. Przechowywanie i zabezpieczenie danych</h2>
        <ol>
            <li>
                Nagrania z monitoringu przechowywane są przez okres nie dłuższy
                niż 30 dni od dnia ich zarejestrowania, po czym są automatycznie
                usuwane, chyba że stanowią dowód w postępowaniu prowadzonym na
                podstawie prawa lub administrator powziął wiadomość, że mogą one
                stanowić dowód w postępowaniu – wówczas termin przechowywania
                ulega przedłużeniu do czasu prawomocnego zakończenia takiego
                postępowania.
            </li>
            <li>
                Nagrania przechowywane są na zabezpieczonych nośnikach danych,
                do których dostęp mają wyłącznie osoby upoważnione przez
                administratora danych.
            </li>
            <li>Dostęp do nagrań monitoringu jest ewidencjonowany.</li>
        </ol>

        <h2>§5. Udostępnianie danych</h2>
        <ol>
            <li>
                Dane z monitoringu mogą być udostępniane wyłącznie:
                <ul>
                    <li>
                        uprawnionym organom i instytucjom na podstawie przepisów
                        prawa,
                    </li>
                    <li>
                        osobom, których dane dotyczą, na ich wniosek, w zakresie
                        przewidzianym przepisami prawa.
                    </li>
                </ul>
            </li>
            <li>
                Udostępnienie nagrań osobom trzecim może nastąpić wyłącznie w
                przypadku wykazania przez nie istnienia interesu prawnego w
                uzyskaniu dostępu do nagrań.
            </li>
        </ol>

        <h2>§6. Prawa osób, których dane dotyczą</h2>
        <ol>
            <li>
                Osoby, których wizerunek został zarejestrowany przez system
                monitoringu, mają prawo do:
                <ul>
                    <li>dostępu do swoich danych osobowych,</li>
                    <li>sprostowania danych,</li>
                    <li>usunięcia danych,</li>
                    <li>ograniczenia przetwarzania,</li>
                    <li>wniesienia sprzeciwu wobec przetwarzania,</li>
                    <li>
                        wniesienia skargi do Prezesa Urzędu Ochrony Danych
                        Osobowych.
                    </li>
                </ul>
            </li>
        </ol>

        <h2>§7. Informowanie o monitoringu</h2>
        <ol>
            <li>
                Informacja o prowadzeniu monitoringu wizyjnego jest przekazywana
                poprzez:
                <ul>
                    <li>
                        umieszczenie odpowiednich tabliczek informacyjnych z
                        piktogramem kamery przy wejściach do Klubu oraz w
                        miejscach objętych monitoringiem,
                    </li>
                    <li>
                        zamieszczenie klauzuli informacyjnej w recepcji Klubu
                        oraz na stronie internetowej Klubu.
                    </li>
                </ul>
            </li>
        </ol>

        <h2>§8. Postanowienia końcowe</h2>
        <ol>
            <li>
                Administratorem danych osobowych pozyskanych w wyniku
                monitoringu jest Holistic Sport Center Sp. z o.o. z siedzibą
                przy ul. Krakowskiej 29C, 50-424 Wrocław.
            </li>
            <li>
                W sprawach nieuregulowanych niniejszym regulaminem zastosowanie
                mają przepisy RODO oraz Kodeksu pracy.
            </li>
        </ol>
    </div>
</template>

<script>
export default {
    name: "Policy",
};
</script>

<style scoped>
.container {
    width: 90vw;
    margin: 5vw auto;
    font-family: Montserrat;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.75rem;
    letter-spacing: -0.00563rem;
}

h1 {
    margin: 5vw auto;
    text-align: center;
}

h2 {
    margin: 1vw auto;
    text-align: center;
}

ul {
    margin: 0.5vw auto;
    text-align: justify;
}

li {
    width: 80%;
    margin: 0 auto;
    text-align: justify;
}
</style>
